import React, {useState, useEffect} from 'react'
import "./CustomDatatable.css";
import { useNavigate } from 'react-router-dom';
import { BiEdit } from "react-icons/bi"
import Pagination from '../Pagination/Pagination';

const CustomDatatable = (props) => {

    const { columns, data } = props;


    const [pageNumber, setPageNumber] = useState(0);
    const itemsPerPage = 10;
    const pagesVisited = pageNumber * itemsPerPage;

    const navigate = useNavigate();
    let months= ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]


    const changePage = ({ selected }) => {
        let currentPage = selected + 1;
        setPageNumber(selected)
        console.log(selected)
    }

    const pageCount = Math.ceil(data?.length / itemsPerPage);
    let dataReformatted = data?.length > itemsPerPage ? data?.slice(pagesVisited, pagesVisited + itemsPerPage) : data

  return (
    <div className="table-responsive ">
                <table className="table table-striped dataTable w-100">
                    <thead className="">
                        <tr role={"row"}>
                            {columns && columns.map((item, index) =>
                                <th style={{"color": "dodgerblue"}} className="suivi-taux-theader text-left pl-5" >
                                    {item.label}</th>
                            )}
                            {/* <th className="text-center w-30">Action</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {data?.length != 0 ? dataReformatted?.map((item, index) =>
                            <tr>

                                <td className="text-left pl-5">
                                {/* {pageNumber > 1 ? (itemsPerPage*(pageNumber-1) + (index + 1)) : (index+1)} */}
                                {/* {Math.ceil(data?.length/10) > 1 ? (10 * (Math.ceil(data?.length/10) - 1) + (index + 1)) : (index + 1)} */}
                                    {/* {index + 1} */}
                                    {data?.length > itemsPerPage ? (pageNumber*10) + (index+1) : (index+1)}
                                    </td>
                                <td className="text-left pl-5">
                                    {item.product}
                                </td>
                                <td className="text-left pl-5">
                                    {item.taux}{" %"}
                                </td>
                                <td className="text-left pl-5">
                                    {item.categoryProduct}
                                </td>
                                

                                

                               
                            </tr>
                        ) : <h1 className="ok"></h1>}
                    </tbody>
                </table>
                <Pagination pageCount={pageCount} changePage={changePage} />
            </div>
  )
}

export default CustomDatatable